<template lang="pug">
.create
  v-app-bar.appBar.elevation-dense(app fixed)
    v-btn(text color="primary" to="/")
        v-icon chevron_left
        span Home
    v-spacer
    //-v-btn(outlined color="primary")
        v-icon(left) save
        span Speichern
  .mt-2
    ChooseThemeStep(v-if="currentStep === 1")
    AddInformationsStep(v-if="currentStep === 2")
    SetClipsStep(v-if="currentStep === 3")
    ConfirmStep(v-if="currentStep === 4")
  
  v-toolbar.controlsBar(flat)
    v-container
      .d-flex.justify-space-between.align-center
        v-btn.px-8(depressed @click="previousStep" :disabled="currentStep === 1") {{$t("general.back")}}
        v-spacer
        h4(v-if="currentStep < 4") Step {{currentStep}} / 3
        h4(v-else) 
        v-spacer
        v-btn.px-8.text-normal(depressed color="accent" v-if="currentStep < 4" @click="nextStep") {{currentStep === 3 ? $t("create.toPreview") : $t("general.continue")}}
        v-btn.px-8.text-normal(depressed color="accent" v-else @click="createMotion" :loading="isCreating") {{$t("create.forms.create")}}
</template>

<script>
import ChooseThemeStep from "@/components/creator/ChooseThemeStep";
import AddInformationsStep from "@/components/creator/AddInformationsStep";
import SetClipsStep from "@/components/creator/SetClipsStep";
import ConfirmStep from "@/components/creator/ConfirmStep";
import { mapFields } from "vuex-map-fields";
import { VideoElement } from "@/models";
import { mapGetters } from "vuex";
export default {
  name: "CreatorPage",
  components: {
    ChooseThemeStep,
    AddInformationsStep,
    SetClipsStep,
    ConfirmStep,
  },
  data() {
    return {
      VideoElement,
      submitted: false,
    };
  },

  created() {},
  computed: {
    currentStep: {
      // getter
      get: function () {
        return this.$store.state.create.currentStep;
      },
      // setter
      set: function (newValue) {
        return this.$store.commit("create/set_current_step", newValue);
      },
    },
    ...mapFields("create", {
      selectedTheme: "selectedTheme",
      motionDraft: "motionDraft",
      isCreating: "isCreating",
    }),
    ...mapGetters({ motionDraftValid: "create/motionDraftValid" }),
  },
  beforeRouteLeave(to, from, next) {
    if (this.submitted) {
      this.currentStep = 1;
      next();
    } else {
      const answer = window.confirm(this.$t("alerts.creatorExit"));
      if (answer) {
        this.currentStep = 1;
        next();
      } else {
        next(false);
      }
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.onRefresh);
  },
  beforeDestroy() {
    this.removeRefreshListener();
  },
  methods: {
    onRefresh(event) {
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },
    removeRefreshListener() {
      window.removeEventListener("beforeunload", this.onRefresh);
    },
    nextStep() {
      if (this.currentStep < 4) {
        this.currentStep += 1;
      }
    },
    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep -= 1;
      }
    },

    createMotion() {
      const videosSelected = this.$store.state.create.timelineElements.some(
        (item) => item.element === VideoElement.CLIP
      );
      if (!videosSelected) {
        this.$store.dispatch("shared/SET_SNACKBAR_TIMER", {
          visible: true,
          text: "Du hast noch keine neuen Clips hinzugefügt",
        });
        return;
      }

      if (this.motionDraftValid) {
        const elements = this.$store.state.create.timelineElements.map(
          (element) => ({
            id: element.id,
            type: VideoElement.CLIP,
            overlays: element.overlays,
          })
        );

        const data = {
          title: this.motionDraft.title,
          description: this.motionDraft.description,
          categoryIDs: this.motionDraft.categoryIDs,

          introTitle: this.motionDraft.introTitle,
          inlcudeAudioForClips: this.motionDraft.inlcudeAudioForClips,
          elements,
        };

        this.$store.dispatch("create/CONCAT_VIDEOS", data).then(() => {
          this.submitted = true;
          this.$router.push("/motions");
        });
      } else {
        this.$store.dispatch("shared/SET_SNACKBAR_TIMER", {
          visible: true,
          text: "Die Informationen zu dem Video sind noch nicht vollständig",
        });
      }
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'
.appBar
  background-color: $light !important
.controlsBar
  background: $light !important
  position: sticky
  left: 0
  right: 0
  bottom: 0
</style>
